<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <HorizontalTopbarInside />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" />
      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <Footer />
        <div class="h-text">
        <b-row class="px-4 mt-2">
          <b-col md="3" class="mt-1">
            <h2>{{$t('message.Tests')}}</h2>

          </b-col>
          <b-col md="3">
            <div class="form-group has-search mt-2">
              <span class="fa fa-search form-control-feedback"></span>
              <input type="text" class="form-control" v-model="params.search" :placeholder="$t('message.Search')">
            </div>
          </b-col>
          <b-col md="3">
            <b-form-select
                v-model="params.position_level_id"
                :options="position_level"
                text-field="name"
                value-field="id"
                class="mt-2 form-select"
                @input="getLevel"
            />
          </b-col>
          <b-col md="2">
            <div class="w-100 d-flex justify-content-end">
              <b-button size="lg" variant="outline-success" class="me-2" @click="fetchTests" >
                <i class='bx bx-search'></i>
              </b-button>
              <b-button
                  size="lg"
                  variant="outline-primary"
                  @click="handleAdd"
              ><i class='bx bx-plus'>{{$t('message.Add')}}</i>
              </b-button>
            </div>
          </b-col>
        </b-row>
        </div>
        <div>
          <b-card
              class="mt-3 d-flex"
              style="width: 90%; margin: 0 auto;"
             >
          <b-table
              responsive
              style="width: 100%;"
              striped
              hover
              :items="tests"
              :fields="fields">
            <template #cell(id)="data">
              <span class="text-md text-primary"> {{ (data.index + 1) }}</span>
            </template>
            <template #cell(positions)="{item}">
              <p v-for="(pos, index) in item.positions" :key="index">
                {{pos.name_uz}}
              </p>
            </template>
            <template #cell(is_active)="{item}">
              <div class="form-check form-switch mb-3">
                <input
                    class="form-check-input lg"
                    type="checkbox"
                    @change="changeStatus(item)"
                    v-model="item.is_active"
                />
              </div>
            </template>
            <template #cell(author)="{item}">
              <span v-if="item.author">
                {{item.author.lastname}} {{item.author.firstname}}
              </span>
            </template>
            <template #cell(action)="data">
              <div class="d-flex">
                <b-button
                    variant="warning"
                    size="sm"
                    @click="handleEdit(data.item.id)"
                ><i class='bx bx-pencil'></i>
                </b-button>
                <b-button
                    class="ml-1"
                    size="sm"
                    style="margin-left: 10px"
                    variant="danger"
                    @click="handleDelete(data.item.id)"
                ><i class='bx bx-trash'></i>
                </b-button>
                <b-button
                    class="ml-1"
                    size="sm"
                    style="margin-left: 10px;
              background-color: #185d89"
                    @click="handlePush(data.item.id)"
                >
                  <i class="bx bx-list-ol"></i>
                </b-button>
              </div>
            </template>
          </b-table>
            <div class="w-100 d-flex justify-content-end mt-4">
              <b-pagination
                  v-model="pagination.page"
                  :total-rows="total"
                  :per-page="pagination.pageSize"
                  aria-controls="my-table"
                  @page-click="fetchTests"
              ></b-pagination>
            </div>
          </b-card>
        </div>
        <b-modal
            v-model="activeModal"
            hide-footer
            id="modal-center"
            centered
            size="lg"
            :title="$t('message.Subject_name')">
          <TabModal
              :subject="subject"
              :position="position"
              :position_level="position_level"
              :id="id"
              :activeModal="activeModal"
              @closeModal="modalClose" />
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "../../../../../../../components/side-bar";
import router from "@/router";
import { layoutComputed } from "@/state/helpers";
import {deleteTest, getTests} from "../../../../../../../api/tests";
import {changeTestStatus, createLevelById} from "../../../../../../../api/directories";
import TabModal from "./TabModal";
import {subjectById} from "../../../../../../../api/subject";
import {createPositionById} from "../../../../../../../api/directories";
import Swal from "sweetalert2";
import HorizontalTopbarInside from "../../../../../../../components/horizontal-topbar-inside";

export default {
  name: "Tests",
  components: {
    HorizontalTopbarInside,
    TabModal,
     SideBar
  },
  data() {
    return {
      id: null,
      activeModal: false,
      isMenuCondensed: false,
      position_level:[],
      position_level_id: [],
      position:[],
      subject: [],
      tests: [],
      pagination:{
        page: 1,
        pageSize: 20,
      },
      total: 1,
      fields: [
        {
          key: 'id',
          label: this.$t('message.Id'),
        },
        {
          key: 'subject.subject',
          label: this.$t('message.Subject')
        },
        {
          key:'questions_count',
          label: this.$t('message.Question_numbers')
        },
        {
          key: "author",
          label: this.$t('message.Author')
        },
        {
          key: 'positions',
          label:this.$t('message.Position_level')
        },
        {
          key:'position_level.name',
          label: this.$t('message.Positions')
        },
        {
          key: "time",
          label: this.$t('message.Added_time'),
        },
        {
          key: "questions_count",
          label: this.$t('message.Questions'),
        },
        {
          key: "is_active",
          label: this.$t('message.IsActive')
        },
        {
          key: 'action',
          label: this.$t('message.Action')
        },
      ],
      params: {
        position_level_id: null,
        search: '',
      }
    };
  },
  computed: {
    ...layoutComputed,
  },
  created (){
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
    this.fetchTests()
  },
  methods: {
    getLevel() {
      this.fetchTests()
    },
    fetchTests(){
      getTests(this.params).then(response => {
        this.tests = response.data.data
        this.total = response.data.data.total
      })
      createLevelById().then(response => {
        var locale = this.$i18n.locale;
        this.position_level = response.data.data.map(item => Object.assign({}, {id: item.id,name: item[`name_${locale}`]}));
        this.position_level.unshift({id: null,name: this.$t('message.All')})
      })
    },
    handleAdd() {
      this.id = null;
      this.activeModal = true;
      createLevelById().then(response => {
        this.position_level = response.data.data
      })
      createPositionById().then(response => {
        this.position = response.data.data
      })
      subjectById().then(response => {
        this.subject = response.data.data
      })
    },
    handleEdit(id) {
      this.id = id;
      this.activeModal = true;
    },
    modalClose(){
      this.activeModal = false
      this.fetchTests()
    },
    closeModal(){
      this.activeModal = false
    },
    handlePush(id){
      this.$router.push({name:'test-questions', params: {id}})
    },
    changeStatus(data) {
      changeTestStatus({test_id: data.id,status:data.is_active})
    },
    handleDelete(id) {
      if (id) {
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            // eslint-disable-next-line no-unused-vars
            deleteTest({ id }).then(res => {
              Swal.fire({
                icon: 'success',
                position: 'center',
                title: 'Deleted!',
                text: 'Your file has been deleted.',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
              this.fetchTests()
            })
          } else if (result.dismiss === 'cancel') {
            Swal.fire({
              title: 'Cancelled',
              text: 'Your imaginary file is safe :)',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        })

      }
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
}
</script>

<style scoped>
h2{
  margin-left: 70px;
  margin-bottom: 50px;
  color: #4d63cf;
}
.has-search .form-control {
  padding-left: 28px;
}
.has-search .form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 2.375rem;
  height: 2.375rem;
  line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
}
.bx{
  cursor: pointer;
}
.h-text{
  margin-top: 70px;
}
</style>



